<div class="grid gap-4">
  <div
    class="aspect-w-16 aspect-h-9 rounded-[12px] overflow-hidden select-none"
  >
    <img src="{{ thumbnail }}" class="w-full h-full object-cover" />
  </div>
  <div class="flex flex-col gap-2">
    <div
      class="text-G900 text-h6 md:text-h5 font-medium hover:underline line-clamp-2 cursor-pointer hover:text-cyan-300 transition-all duration-300"
      [routerLink]="['/blog', this.slug]"
    >
      {{ title }}
    </div>
    <div class="text-G700 text-b1 line-clamp-3 md:line-clamp-2">
      {{ subTitle }}
    </div>
  </div>
  <div class="flex flex-wrap gap-2">
    <div *ngFor="let tag of tags">
      <basic-tag [type]="1" [title]="tag" />
    </div>
  </div>
  <div class="flex items-center gap-6">
    <img
      src="{{ thumbnail }}"
      class="w-[48px] h-[48px] rounded-full object-cover overflow-hidden select-none"
    />
    <div class="font-medium">
      <div class="text-G700">{{ author }}</div>
      <div class="text-G500">
        {{ datePosted }} • {{ readingTime() }} min read
      </div>
    </div>
  </div>
</div>
